module.exports = {
	methods: {
		prepare: function(){
			this.model.rentalPriceFormatted = '€ ' + new Intl.NumberFormat('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this.model.rentalPrice);
		}
	}
};